<template>
  <footer class="relative flex items-center justify-end gap-2 border-t border-t-gray-200 p-4 md:px-6">
    <slot />
  </footer>
</template>
